import { render, staticRenderFns } from "./CathayLifeInsuranceForEdit.vue?vue&type=template&id=9991271c"
import script from "./CathayLifeInsuranceForEdit.vue?vue&type=script&lang=js"
export * from "./CathayLifeInsuranceForEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports